import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pie",
  "use": "icon-pie-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pie\"><path d=\"M0 0h64v1024H0z\" p-id=\"4473\" /><path d=\"M0 960h1024v64H0zM896 512a384 384 0 1 1-384-384v384h384z\" p-id=\"4474\" /><path d=\"M955.52 448A448.32 448.32 0 0 0 576 68.48V448h379.52z\" p-id=\"4475\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol